import { BlogIndexHero } from "./BlogIndexHero";
import { FeaturedPost } from "./FeaturedPost";
import { PostList } from "./PostList";
import { POSTS } from "./posts";
import { MarketingPageLayout } from "../../components/MarketingPageLayout";

export function BlogIndexPage() {
  // Guard for the empty case (e.g. mid-edit or before any posts ship) — no
  // featured card, just the "no posts yet" state inside PostList.
  const featured = POSTS.find((p) => p.featured) ?? POSTS[0];
  const rest = featured ? POSTS.filter((p) => p.id !== featured.id) : POSTS;

  return (
    <MarketingPageLayout current="blog">
      <BlogIndexHero />
      {featured && <FeaturedPost post={featured} />}
      <PostList posts={rest} />
    </MarketingPageLayout>
  );
}
